import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

interface UseCreatePublicCompanyLeadSpecialFeeProps {
  publicCompanyLeadId?: string
  onSuccess?: () => void
  onError?: (error: ErrorResponse) => void
}

export const useCreatePublicCompanyLeadSpecialFee = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseCreatePublicCompanyLeadSpecialFeeProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createPublicCompanyLeadSpecialFee'],
    mutationFn: async (data: { value: string; type: string; fee_template_id: string }) => {
      const lead = {
        fee_rule_attributes: {
          special_entries_attributes: [
            {
              target_id: data.value === 'all' ? null : data.value,
              target_type: data.type,
              fee_template_id: data.fee_template_id,
            },
          ],
        },
      }

      await privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
